






































import { Component, Prop, Vue } from 'vue-property-decorator'

import formItem from '@/components/formItem.vue'

@Component({
  name: 'AppPageOption',
  components: {
    formItem
  }
})
export default class AppPageOption extends Vue {
  @Prop({ default: null })
  private option: any
}
